// Structural mirrors of the RateBreakdown* shapes generated in
// src/api/FiretrolApiClient. lib/ may not import the API client (see
// docs/frontend-enforcement-plan.md §2.1), so these interfaces describe only
// the fields EffectiveRateBreakdown/EffectiveRateCell actually read. NSwag
// DTO instances satisfy them structurally — callers keep passing DTOs
// unchanged, no adapter needed.

/**
 * Mirrors RateBreakdownScenario's numeric values. Kept as a plain object
 * (not a TS enum) because TS enums are nominal — a value of the API's
 * RateBreakdownScenario enum would not be assignable to a differently-named
 * local enum, only to a plain `number` field. `RateBreakdownScenarioValue`
 * (the literal union derived below) doesn't have that problem — the API's
 * numeric enum members are those literals — so callers' `scenario` fields
 * should be typed with the union, not `number`.
 */
export const RATE_BREAKDOWN_SCENARIO = {
  NonScale: 0,
  ScaleBypassed: 1,
  ScaleNotApplied: 2,
  ScaleApplied: 3,
  ScaleOvertime: 4,
} as const;

/** Mirrors RateFormulaValueFormat's numeric values; see RATE_BREAKDOWN_SCENARIO for why this isn't a TS enum. */
export const RATE_FORMULA_VALUE_FORMAT = {
  Currency: 0,
  Multiplier: 1,
} as const;

export type RateBreakdownScenarioValue =
  typeof RATE_BREAKDOWN_SCENARIO[keyof typeof RATE_BREAKDOWN_SCENARIO];
export type RateFormulaValueFormatValue =
  typeof RATE_FORMULA_VALUE_FORMAT[keyof typeof RATE_FORMULA_VALUE_FORMAT];

export interface IRateBreakdownBadge {
  label: string;
  color: string;
}

export interface IRateFormulaStep {
  label: string;
  value: number;
  format: RateFormulaValueFormatValue;
  operatorAfter?: string;
  highlight: boolean;
  span: number;
}

export interface IRateScaleDerivation {
  scaleBaseRate?: number;
  effectiveScaleBaseRate?: number;
  scaleFringeRate?: number;
  effectiveScaleFringeRate?: number;
  levelRateModifierPercent?: number;
  baseRate: number;
  baseBenefitRate: number;
  actualTotalComp: number;
  scaleTotalComp: number;
  scalePayAdjustmentAmount: number;
}

export interface IRateScaleOvertimeDerivation {
  scaleBaseRate?: number;
  effectiveScaleBaseRate?: number;
  scaleFringeRate?: number;
  effectiveScaleFringeRate?: number;
  levelRateModifierPercent?: number;
  baseBenefitRate?: number | null;
  fringeDelta: number;
}

export interface IRateScaleNotAppliedDerivation {
  jobClassificationLevelRateFound?: boolean;
  scaleBaseRate?: number;
  effectiveScaleBaseRate?: number;
  scaleFringeRate?: number;
  effectiveScaleFringeRate?: number;
  levelRateModifierPercent?: number;
  baseRate: number;
  baseBenefitRate?: number | null;
  userClassificationName?: string | null;
  jobConfiguredClassificationNames?: string[] | null;
}

export interface IRateBreakdownInstructions {
  scenario: RateBreakdownScenarioValue;
  badge?: IRateBreakdownBadge;
  formulaTitle: string;
  formulaSteps: IRateFormulaStep[];
  scaleDerivation?: IRateScaleDerivation;
  scaleOvertimeDerivation?: IRateScaleOvertimeDerivation;
  scaleNotAppliedDerivation?: IRateScaleNotAppliedDerivation;
}

// Structural mirrors of TimesheetHistoryDto/TimesheetRowDto/WbsAccountSummary
// fields read by TimesheetHistoryPanel and modules/timesheets/utils — same
// rule as the RateBreakdown* mirrors above, and for the same reason: NSwag
// DTO instances satisfy them structurally, so callers keep passing DTOs
// unchanged and no adapter is needed.

/** TimesheetHistoryDto.id is a string (guid); mirrored as such rather than the number some earlier drafts assumed. */
export interface ITimesheetHistoryEntry {
  id?: string;
  oldStatus?: string;
  newStatus?: string;
  message?: string;
  createdAt?: Date;
  createdBy?: { fullName?: string };
}

export interface ITimesheetRow {
  total: number;
  sat: number;
  sun: number;
  mon: number;
  tue: number;
  wed: number;
  thu: number;
  fri: number;
}

export interface IWbsAccountPayType {
  hours: {
    sat: number;
    sun: number;
    mon: number;
    tue: number;
    wed: number;
    thu: number;
    fri: number;
  };
}

export interface IWbsAccount {
  account?: { perDiemEligible?: boolean };
  payTypes: IWbsAccountPayType[];
}
